import { combineReducers } from 'redux-immutable';
import { Record } from 'immutable';
import authentication from './Authentication';
import search from './Search';
import routing from './Routing';
import user from './User';
import company from './Company';
import passwordReset from './PasswordReset';
import audit from './Audit';

const StoreStateRecord = Record({
  audit: audit,
  authentication: authentication,
  search: search,
  user: user,
  routing: routing,
  company: company,
  passwordReset: passwordReset,
});

export default combineReducers(
  {
    audit,
    authentication,
    routing,
    search,
    user,
    company,
    passwordReset,
  },
  StoreStateRecord
);
